// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2OexE","info":"UpdateTermsInfo_info__2D4OI"};